import script from "./leagueView.vue?vue&type=script&lang=ts&setup=true"
export * from "./leagueView.vue?vue&type=script&lang=ts&setup=true"

import "./leagueView.vue?vue&type=style&index=0&id=e14952a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e14952a2"]])

export default __exports__